// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 178) return "static/chunks/syntax-5088eb0765772dbc.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"411":"media","493":"security"}[chunkId] || chunkId) + "." + {"81":"81ac1884c6c8a38c","411":"75c74a6d9a5f1354","493":"34a85fbf497c8510","907":"c36adf5ba9c5b511"}[chunkId] + ".js";
};